export default {
    alisonJS: import.meta.env.VUE_APP_ALISON_JS,
    alisonGUI: import.meta.env.VUE_APP_ALISON_GUI,

		// APi de TadServer backend
    tadServerApiUrl: import.meta.env.VUE_APP_TAD_SERVER_API_URL,
    tadServerUseClientKey: import.meta.env.VUE_APP_TAD_SERVER_USE_CLIENT_KEY,
    tadServerUseClientSecret: import.meta.env.VUE_APP_TAD_SERVER_USE_CLIENT_SECRET,
    tadServerTenant: import.meta.env.VUE_APP_TAD_SERVER_TENANT,
    tadServerSeat: import.meta.env.VUE_APP_TAD_SERVER_SEAT,

    // APi de AlisonServer backend
    alisonServerApiUrl: import.meta.env.VUE_APP_ALISON_SERVER_API_URL,
    webauthnUserPanelUrl: import.meta.env.VUE_APP_USER_PANEL_URL,
    alisonServerGenClientKey: import.meta.env.VUE_APP_ALISON_SERVER_GEN_CLIENT_KEY,
    alisonServerGenClientSecret: import.meta.env.VUE_APP_ALISON_SERVER_GEN_CLIENT_SECRET,
    alisonServerUseClientKey: import.meta.env.VUE_APP_ALISON_SERVER_USE_CLIENT_KEY,
    alisonServerUseClientSecret: import.meta.env.VUE_APP_ALISON_SERVER_USE_CLIENT_SECRET,
    alisonServerTenant: import.meta.env.VUE_APP_ALISON_SERVER_TENANT,
    alisonServerSeat: import.meta.env.VUE_APP_ALISON_SERVER_SEAT

}
